import { render, staticRenderFns } from "./race.vue?vue&type=template&id=409fa0de"
import script from "./race.vue?vue&type=script&lang=js"
export * from "./race.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports